import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@app/services';
import { ToastrService } from 'ngx-toastr';
import {Observable, of, ReplaySubject} from "rxjs";
interface banks {
  id: string;
  name: string;
}


@Component({
  selector: 'mnf-modal-add-bankaccount',
  templateUrl: './modal-add-bankaccount.component.html',
  styleUrls: ['./modal-add-bankaccount.component.scss']
})


export class ModalAddBankaccountComponent implements OnInit {
  banksById = [
    {id: '40138', name: 'ABC CAPITAL'},
    {id: '40133', name: 'ACTINVER'},
    {id: '40062', name: 'AFIRME'},
    {id: '90706', name: 'ARCUS'},
    {id: '90659', name: 'ASP INTEGRA OPC'},
    {id: '40128', name: 'AUTOFIN'},
    {id: '40127', name: 'AZTECA'},
    {id: '37166', name: 'BaBien'},
    {id: '40030', name: 'BAJIO'},
    {id: '40002', name: 'BANAMEX'},
    {id: '40154', name: 'BANCO COVALTO'},
    {id: '37006', name: 'BANCOMEXT'},
    {id: '40137', name: 'BANCOPPEL'},
    {id: '40160', name: 'BANCO S3'},
    {id: '40152', name: 'BANCREA'},
    {id: '37019', name: 'BANJERCITO'},
    {id: '40147', name: 'BANKAOOL'},
    {id: '40106', name: 'BANK OF AMERICA'},
    {id: '40159', name: 'BANK OF CHINA'},
    {id: '37009', name: 'BANOBRAS'},
    {id: '40072', name: 'BANORTE'},
    {id: '40058', name: 'BANREGIO'},
    {id: '40060', name: 'BANSI'},
    {id: '2001',  name: 'BANXICO'},
    {id: '40129', name: 'BARCLAYS'},
    {id: '40145', name: 'BBASE'},
    {id: '40012', name: 'BBVA MEXICO'},
    {id: '40112', name: 'BMONEX'},
    {id: '90677', name: 'CAJA POP MEXICA'},
    {id: '90683', name: 'CAJA TELEFONIST'},
    {id: '90630', name: 'CB INTERCAM'},
    {id: '40143', name: 'CIBANCO'},
    {id: '90631', name: 'CI BOLSA'},
    {id: '90901', name: 'CLS'},
    {id: '90903', name: 'CoDi Valida'},
    {id: '40130', name: 'COMPARTAMOS'},
    {id: '40140', name: 'CONSUBANCO'},
    {id: '90652', name: 'CREDICAPITAL'},
    {id: '90688', name: 'CREDICLUB'},
    {id: '90680', name: 'CRISTOBAL COLON'},
    {id: '90723', name: 'Cuenca'},
    {id: '40151', name: 'DONDE'},
    {id: '90616', name: 'FINAMEX'},
    {id: '90634', name: 'FINCOMUN'},
    {id: '90689', name: 'FOMPED'},
    {id: '90685', name: 'FONDO (FIRA)'},
    {id: '90601', name: 'GBM'},
    {id: '37168', name: 'HIPOTECARIA FED'},
    {id: '40021', name: 'HSBC'},
    {id: '40155', name: 'ICBC'},
    {id: '40036', name: 'INBURSA'},
    {id: '90902', name: 'INDEVAL'},
    {id: '40150', name: 'INMOBILIARIO'},
    {id: '40136', name: 'INTERCAM BANCO'},
    {id: '40059', name: 'INVEX'},
    {id: '40110', name: 'JP MORGAN'},
    {id: '90661', name: 'KLAR'},
    {id: '90653', name: 'KUSPIT'},
    {id: '90670', name: 'LIBERTAD'},
    {id: '90602', name: 'MASARI'},
    {id: '90722', name: 'Mercado Pago W'},
    {id: '40042', name: 'MIFEL'},
    {id: '40158', name: 'MIZUHO BANK'},
    {id: '90600', name: 'MONEXCB'},
    {id: '40108', name: 'MUFG'},
    {id: '40132', name: 'MULTIVA BANCO'},
    {id: '37135', name: 'NAFIN'},
    {id: '90638', name: 'NU MEXICO'},
    {id: '90710', name: 'NVIO'},
    {id: '40148', name: 'PAGATODO'},
    {id: '90620', name: 'PROFUTURO'},
    {id: '40156', name: 'SABADELL'},
    {id: '40014', name: 'SANTANDER'},
    {id: '40044', name: 'SCOTIABANK'},
    {id: '40157', name: 'SHINHAN'},
    {id: '90646', name: 'STP'},
    {id: '90703', name: 'TESORED'},
    {id: '90684', name: 'TRANSFER'},
    {id: '90656', name: 'UNAGRA'},
    {id: '90617', name: 'VALMEX'},
    {id: '90605', name: 'VALUE'},
    {id: '90608', name: 'VECTOR'},
    {id: '40113', name: 'VE POR MAS'},
    {id: '40141', name: 'VOLKSWAGEN'}
  ];
  /** list of banks filtered by search keyword */
  public filteredBanks: ReplaySubject<banks[]> = new ReplaySubject<banks[]>(1);
  accountForm: UntypedFormGroup;

  constructor(
    private modalRef: MatDialogRef<ModalAddBankaccountComponent>,
    private fb: UntypedFormBuilder,
    private userServ: UserService,
    private toastr: ToastrService
  ) { }

  get account() {
    return this.accountForm.controls;
  }

  ngOnInit(): void {
    // load the initial bank list
    this.filteredBanks.next(this.banksById);

    this.accountForm = this.fb.group({
      clabe: ['', Validators.compose([Validators.required, Validators.minLength(18)])],
      bankId: ['', Validators.required],
      bankFilter: '',
      alias: ['', Validators.compose([Validators.required, Validators.minLength(2)])]
    });

  }

  bankFilter(fil: string) {
    let search = this.accountForm.controls.bankFilter.value;
    this.filteredBanks.next(
      this.banksById.filter(bank => bank.name.toLowerCase().indexOf(search) > -1)
    );
  }

  // addAccount() {
  //   if (this.accountForm.valid) {
  //     const { clabe, alias, bankId } = this.accountForm.value;

  //     this.userServ.addBankAccount(alias, bankId, clabe).subscribe(() => {
  //       this.toastr.success(`Se ha agregado la cuenta: ${alias}`, 'Éxito');
  //       this.modalRef.close(true);
  //     }, () => this.toastr.warning('Ha ocurrido un error al dar de alta tu cuenta'));
  //   }
  // }

  close() {
    this.modalRef.close();
  }

}
